import { useEffect, useState } from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";
import Curriculum from "./Curriculum";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PayPalIntegration from "../../components/payments/PayPalIntegration";
import { useProfile } from "../../context/ProfileContext";
import {useTeacherTotalCourses} from '../../hooks/useTeacherTotalCourses'
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const CourseDetailsPage = () => {
  const navigate=useNavigate()
  const {profileId}=useProfile()
  const location = useLocation()
  const {type} = location?.state
  // console.log("The type is:",type)
  const {teacher_id,learning_type,id}=useParams()
  const total = useTeacherTotalCourses(type,Number(teacher_id));
  const [currentCourse,setCurrentCourse]=useState([])
  const [previewFile,setPreviewFile]=useState(null)
  const [additionalResources,setAdditionalResources] = useState(false)
  // console.log("The current course is:",currentCourse)
useEffect(() => {
  const fetchCourse = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/courses/${id}/public/?learning_type=${learning_type}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        }
      );
      setCurrentCourse(response.data);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };
  fetchCourse();
}, [learning_type, id]);
  if(!currentCourse) return null

const AddtoPlayList = async (course) => {
  // console.log(course)
  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify(course));
    formData.append("profile_id",profileId)
    const response = await fetch(`${BASE_URL}/student/playlist/`, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "x-api-key": process.env.REACT_APP_X_API_KEY
      },
    });

    const data = await response.json();

    if (response.ok) {
      alert("Course successfully added to your playlist");
      navigate('/student/playlist');
    } else {
      // Check duplicate error here
      if (data.message === "Course already in your playlist") {
        alert("This course is already in your playlist!");
        navigate('/student/playlist');
      } else {
        alert(data.error || "Failed to add course");
      }
    }
  } catch (error) {
    alert("Something went wrong: " + error);
  }
};

  return (
<>
  <Header />
  <div className="bg-gray-50 min-h-screen">
  <div className="w-full  mx-auto px-2 md:px-12 py-8 grid grid-cols-1 lg:grid-cols-[1fr_380px] gap-8">
    {/* Main Content */}
    <div className="flex flex-col gap-6">
      {/* Course Content Sections */}
      <div className="flex flex-col gap-6">
        {/* Course Overview */}
        <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm">
          <div className="flex items-center gap-3 mb-6">
             <h1 className="text-3xl font-bold text-gray-900 mb-4">
          {currentCourse.name}
        </h1>
          </div>
          <p className="text-gray-600 leading-relaxed mb-8">
            {currentCourse.description}
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl border border-gray-200">
              <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                </svg>
              </div>
              <span className="text-sm font-medium text-gray-700">Lifetime access</span>
            </div>
            <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl border border-gray-200">
              <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <span className="text-sm font-medium text-gray-700">Certificate of completion</span>
            </div>
            <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl border border-gray-200">
              <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <span className="text-sm font-medium text-gray-700">Mobile and desktop access</span>
            </div>
            <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl border border-gray-200">
              <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              </div>
              <span className="text-sm font-medium text-gray-700">Downloadable resources</span>
            </div>
          </div>
        </div>

        {/* What You'll Learn */}
        <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-1.5 h-6 bg-[#0f6abf] rounded-full"></div>
            <h3 className="text-xl font-semibold text-gray-900">What You'll Learn</h3>
          </div>
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span className="text-gray-700">Understand core concepts and principles</span>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span className="text-gray-700">Apply practical, real-world skills</span>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span className="text-gray-700">Complete hands-on projects or exercises</span>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span className="text-gray-700">Measure and improve your performance</span>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span className="text-gray-700">Earn a certificate of completion</span>
            </div>
          </div>
        </div>

        {/* Curriculum */}
        {learning_type === '1' && currentCourse?.modules?.length > 0 && currentCourse?.modules && (
          <Curriculum currentCourse={currentCourse} setPreviewFile={setPreviewFile} />
        )}

        {/* Instructor */}
        {currentCourse?.teacher && currentCourse?.teacher.university ? (
          <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm">
            <div className="flex items-start gap-4">
              <img 
                src={currentCourse?.teacher?.university_data?.university_logo} 
                alt="Instructor" 
                className="w-20 h-20 rounded-full object-cover border-2 border-white shadow-sm cursor-pointer"
                onClick={() => navigate(`/marketplace/university/${currentCourse?.teacher?.university_data?.id}`)}
              />
              <div className="flex-1">
                <h4 className="text-lg font-semibold text-gray-900 mb-1">
                  {currentCourse?.teacher?.university_data?.university_name}
                </h4>
                {/* <p className="text-sm text-gray-600">
                  {currentCourse?.teacher?.experience?.experienceDescription}
                </p> */}
                <div className="mt-3">
                  <span className="text-sm font-medium text-gray-700">Total Courses: </span>
                  <span className="text-sm text-gray-900 font-semibold">{total}</span>
                </div>
              </div>
            </div>
          </div>
        ) : 
        (
          <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm">
            <div className="flex items-start gap-4">
              <img 
                src={currentCourse?.teacher?.user?.profile_image} 
                alt="Instructor" 
                className="w-20 h-20 rounded-full object-cover border-2 border-white shadow-sm cursor-pointer"
                onClick={() => navigate(`/teacher-profile/${currentCourse?.teacher?.id}`)}
              />
              <div className="flex-1">
                <h4 className="text-lg font-semibold text-gray-900 mb-1">
                  {currentCourse?.teacher?.user?.name}
                </h4>
                <p className="text-sm text-gray-600">
                  {currentCourse?.teacher?.experience?.experienceDescription}
                </p>
                <div className="mt-3">
                  <span className="text-sm font-medium text-gray-700">Total Courses: </span>
                  <span className="text-sm text-gray-900 font-semibold">{total}</span>
                </div>
              </div>
            </div>
          </div>
        )
        }
      </div>
    </div>

    {/* Sidebar */}
    <div className="flex flex-col gap-6">
      <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm sticky top-24">
        {/* Course Preview */}
        <div className="mb-6">
          <div className="rounded-xl overflow-hidden bg-gray-50 border border-gray-200">
            {learning_type === '1' && (
              <>
                {previewFile === null ? (
                  <img 
                    src={currentCourse.image} 
                    alt="Course Preview" 
                    className="w-full h-48 object-cover"
                  />
                ) : (
                  <video
                    src={previewFile}
                    className="w-full h-48 object-cover"
                    controls
                  />
                )}
              </>
            )}
            {learning_type === '2' && (
              <div className="relative">
                <video
                  src={currentCourse.file}
                  className="w-full object-cover"
                  controls={currentCourse.payment_status === "paid" || currentCourse.course_type === "free"}
                />
                {currentCourse.payment_status !== "paid" && currentCourse.course_type !== "free" && (
                  <div
                    className="absolute inset-0 bg-black/60 flex items-center justify-center cursor-not-allowed"
                    onClick={() => alert("Payment required to play this video")}
                  >
                    <div className="w-12 h-12 bg-white/20 backdrop-blur rounded-full flex items-center justify-center">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                      </svg>
                    </div>
                    <span className="text-white text-sm ml-2">Locked</span>
                  </div>
                )}
              </div>
            )}
            {learning_type === '3' && (
              <div className="relative p-4">
                <audio
                  src={currentCourse.file}
                  className="w-full"
                  controls={currentCourse.payment_status === "paid" || currentCourse.course_type === "free"}
                />
                {currentCourse.payment_status !== "paid" && currentCourse.course_type !== "free" && (
                  <div className="absolute inset-0 bg-black/60 flex items-center justify-center pointer-events-none">
                    <div className="w-10 h-10 bg-white/20 backdrop-blur rounded-full flex items-center justify-center">
                      <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                      </svg>
                    </div>
                    <span className="text-white text-sm ml-2">Locked</span>
                  </div>
                )}
              </div>
            )}
            {learning_type === '4' && (
              <div className="relative">
                <video
                  src={currentCourse.file}
                  className="w-full object-cover"
                  controls={currentCourse.payment_status === "paid" || currentCourse.course_type === "free"}
                />
                {currentCourse.payment_status !== "paid" && currentCourse.course_type !== "free" && (
                  <div
                    className="absolute inset-0 bg-black/60 flex items-center justify-center cursor-not-allowed"
                    onClick={() => alert("Payment required to play this video")}
                  >
                    <div className="w-12 h-12 bg-white/20 backdrop-blur rounded-full flex items-center justify-center">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                      </svg>
                    </div>
                    <span className="text-white text-sm ml-2">Locked</span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Pricing & Actions */}
        {currentCourse.course_type === 'paid' ? (
          <>
            <div className="flex items-baseline gap-2 mb-6">
              <span className="text-3xl font-bold text-[#0f6abf]">${currentCourse.price}</span>
            </div>
            <div className="action-buttons">
              {currentCourse?.payment_status !== "paid" && (
                <PayPalIntegration currentCourse={currentCourse} />
              )}
            </div>
          </>
        ) : (
          <>
            {learning_type === '1' && (
              <div className="action-buttons">
                <button
                  onClick={() => AddtoPlayList(currentCourse)}
                  className="w-full flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-[#0f6abf] text-white font-medium hover:bg-[#0a5ca8] transition-colors"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                  </svg>
                  Add to Playlist
                </button>
              </div>
            )}
          </>
        )}

        {/* Service Features */}
        <div className="mt-6 pt-6 border-t border-gray-200">
          <div className="space-y-3">
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-4 h-4 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span className="text-sm text-gray-700">Lifetime Access</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-4 h-4 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span className="text-sm text-gray-700">Downloadable Resources</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-4 h-4 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span className="text-sm text-gray-700">Q&A Support</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-4 h-4 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span className="text-sm text-gray-700">Assignments Reviewed</span>
            </div>
          </div>
        </div>

        {/* Additional Resources */}
        <div className="service-features mt-6">
          {currentCourse?.resources?.length > 0 && currentCourse.course_type === 'free' && (
            <>
              <button
                onClick={() => setAdditionalResources(!additionalResources)}
                className="text-[#0f6abf] text-sm font-medium p-2 bg-[#e8f0f7] rounded-lg hover:bg-[#d0e0f0] transition-colors"
              >
                Additional Resources
              </button>
              {additionalResources && (
                <div className="mt-3 space-y-2">
                  {currentCourse?.resources?.map((resource, index) => (
                    <a
                      key={index}
                      href={resource.file}
                      target="_blank"
                      className="block break-words text-sm text-[#0f6abf] hover:underline p-2 bg-gray-50 rounded-lg"
                      rel="noopener noreferrer"
                    >
                      {resource.file}
                    </a>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  </div>
</div>
  <Footer />
</>
  );
};

export default CourseDetailsPage;